import Vue from 'vue'
import VueResource from 'vue-resource'
import { sync } from 'vuex-router-sync'
import * as env from './env'
import * as config from './config'
import AsyncComputed from 'vue-async-computed'
import router from './router'
import store from './store'
import filters from './filters'
import mixin from './mixin'
import App from './App'
import VueAnalytics from 'vue-analytics'
import VueCryptojs from 'vue-cryptojs'

// Components import
// Vue plugins configuration
Vue.use(VueResource)
Vue.use(AsyncComputed)

let idGA = 'UA-135025349-5' // Display - PRODUÇÃO
if (process.env.NODE_ENV !== 'production') {
  idGA = 'UA-1941696-6' // Display - DEV
}
Vue.use(VueAnalytics, {
  id: idGA,
  router,
  autoTracking: {
    page: true
  }
})

const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)

Vue.use(VueCryptojs)

// Components
Vue.component('app', App)

import InputCep from './components/forms/inputs/InputCep'
import InputStates from './components/forms/inputs/InputStates'
import InputCities from './components/forms/inputs/InputCities'
import InputNeighborhoods from './components/forms/inputs/InputNeighborhoods'
import InputNumber from './components/forms/inputs/InputNumber'
import InputSelect from './components/forms/inputs/InputSelect'
import InputText from './components/forms/inputs/InputText'
import InputPhone from './components/forms/inputs/InputPhone'
import InputTextarea from './components/forms/inputs/InputTextarea'
import InputDate from './components/forms/inputs/InputDate'
import InputEmail from './components/forms/inputs/InputEmail'
import InputPassword from './components/forms/inputs/InputPassword'
import InputFile from './components/forms/inputs/InputFile'
import PaginationBootstrap from './components/bootstrap/PaginationBootstrap'
import ModalBootstrap from './components/bootstrap/ModalBootstrap'
import Loading from './components/app/Loading'
import FormSearchSkus from './components/forms/FormSearchSkus'
import { buttonGroup, radio, typeahead, tabs, tabGroup, tab } from 'vue-strap'

Vue.component('tabs', tabs)
Vue.component('tabGroup', tabGroup)
Vue.component('tab', tab)
Vue.component('typeahead', typeahead)
Vue.component('radio', radio)
Vue.component('button-group', buttonGroup)
Vue.component('input-cep', InputCep)
Vue.component('input-states', InputStates)
Vue.component('input-cities', InputCities)
Vue.component('input-neighborhoods', InputNeighborhoods)
Vue.component('input-number', InputNumber)
Vue.component('input-select', InputSelect)
Vue.component('input-text', InputText)
Vue.component('input-phone', InputPhone)
Vue.component('input-textarea', InputTextarea)
Vue.component('input-date', InputDate)
Vue.component('input-email', InputEmail)
Vue.component('input-password', InputPassword)
Vue.component('input-file', InputFile)
Vue.component('pagination-bootstrap', PaginationBootstrap)
Vue.component('modal-bootstrap', ModalBootstrap)
Vue.component('loading', Loading)
Vue.component('form-search-skus', FormSearchSkus)

sync(store, router)

Vue.http.options.root = config.apiURL
Vue.http.interceptors.push((request, next) => {
  let displayName = window.location.host.split('.')[0]
  request.url += (request.url.indexOf('?') === -1 ? '?' : '&') + 'display_name=' + displayName
  request.headers.set('Accept', 'application/json')
  if (store.state.user.access_token) {
    request.headers.set('Authorization', 'Bearer ' + store.state.user.access_token)
    request.headers.set('ClientId', env.clientId)
  }
  next((response) => {
    if (response.status === 500) {
      // router.push({name: 'error500'})
    } else if (response.status === 404) {
      router.push({name: 'error404'})
    } else if (response.status === 401) {
      store.commit('UNSET_USER')
      if (!['login', 'checkout', 'company_registration'].includes(router.history.current.name)) {
        router.push({name: 'login'})
      }
    }
    if (response.data.access_token) store.commit('CHANGE_USER', response.data)
    // if (response.data.user && response.data.user.access_token) store.commit('CHANGE_USER', response.data.user)
  })
})

Vue.config.keyCodes = {
  'enter': [13],
  'arrow-keys': [37, 38, 39, 40],
  'arrow-vertical-keys': [38, 40],
  'arrow-horizontal-keys': [37, 39]
}

new Vue({
  router,
  store,
  filters,
  mixin
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js